import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    activeItem: 0,
    isSidebarCollapsed: false,
    dashboardDataChanged: false,
    activeCampaings: 0,
    unpaidOrders: 0,
};

const MiscSlice = createSlice({
    name: 'misc',
    initialState,
    reducers: {
        setActiveItem(state, action) {
            state.activeItem = action?.payload;
        },

        toggleSidebar(state) {
            state.isSidebarCollapsed = !state.isSidebarCollapsed;
        },

        setDashboardDataChanged(state, action) {
            state.dashboardDataChanged = action?.payload;
        },

        setActiveCampaings(state, action) {
            state.activeCampaings = action?.payload;
        },

        setUnpaidOrders(state, action) {
            state.unpaidOrders = action?.payload;
        },
    },
});

export const { setActiveItem, setDashboardDataChanged, setActiveCampaings, setUnpaidOrders, setStripeTokenGlobally, toggleSidebar } = MiscSlice.actions;
export default MiscSlice.reducer;
